var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"xer-application-content",attrs:{"id":"app"}},[(_vm.rootStore.error)?_c('oeps',{attrs:{"error-component":_vm.rootStore.error.component,"error-component-props":_vm.rootStore.error.props}}):_c('router-view'),_c('xer-notification')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }